import React, { FC, useState } from "react";
// libs
import take from "lodash/take";
import slice from "lodash/slice";
// components
import DropdownAnimated from "src/components/ui/Dropdown/Animated";
import Button from "src/components/ui/button";
// hooks
import { useWindowSize } from "src/hooks/useWindowSize";
// const
import { sizesMedia } from "src/constants/media";
import { EVariants } from "src/constants/variants";
import {
  Wrapper,
  Content,
  Title,
  ButtonContainer,
  DropdownWrapper,
  ListWrapper,
  PlacesWrapper,
  PlacesColumn,
  Wawes,
} from "./FindClinics.styles";
import { amplitudeEvent, formatEventName } from "src/libs/amplitude";
import { useRouter } from "next/router";

interface IFindClinics {
  cities: string[];
}

const FindClinics: FC<IFindClinics> = ({ cities }) => {
  const size = useWindowSize();
  const { pathname } = useRouter();

  const [showAll, setShowAll] = useState(false);

  const toggleShowAll = () => setShowAll(!showAll);

  const trackCityClick = () => {
    amplitudeEvent(formatEventName(pathname, "cities", "city"));
  };

  return (
    <Wrapper>
      <Wawes />
      <Content>
        <Title>Find clinics by city</Title>

        {size.width < sizesMedia.laptop && (
          <ListWrapper>
            {(showAll ? slice(cities, 0, 20) : take(cities, 5)).map((item: any) => (
              <DropdownWrapper key={item.city || item.town}>
                <DropdownAnimated
                  state={item.state}
                  city={item.city || item.town}
                  areas={item.suburbs}
                />
              </DropdownWrapper>
            ))}
            <ButtonContainer>
              <Button
                variant={EVariants.QUATERNARY}
                style={{ width: "100%" }}
                onClick={toggleShowAll}
              >
                {showAll ? "Show less" : "Show more"}
              </Button>
            </ButtonContainer>
          </ListWrapper>
        )}

        {size.width >= sizesMedia.laptop && (
          <PlacesWrapper>
            <PlacesColumn>
              {slice(cities, 0, 5).map((item: any) => (
                <DropdownWrapper key={item.city || item.town} onClick={trackCityClick}>
                  <DropdownAnimated
                    state={item.state}
                    city={item.city || item.town}
                    areas={item.suburbs}
                  />
                </DropdownWrapper>
              ))}
            </PlacesColumn>

            <PlacesColumn>
              {slice(cities, 5, 10).map((item: any) => (
                <DropdownWrapper key={item.city || item.town} onClick={trackCityClick}>
                  <DropdownAnimated
                    state={item.state}
                    city={item.city || item.town}
                    areas={item.suburbs}
                  />
                </DropdownWrapper>
              ))}
            </PlacesColumn>

            <PlacesColumn>
              {slice(cities, 10, 15).map((item: any) => (
                <DropdownWrapper key={item.city || item.town} onClick={trackCityClick}>
                  <DropdownAnimated
                    state={item.state}
                    city={item.city || item.town}
                    areas={item.suburbs}
                  />
                </DropdownWrapper>
              ))}
            </PlacesColumn>

            <PlacesColumn>
              {slice(cities, 15, 20).map((item: any) => (
                <DropdownWrapper key={item.city || item.town} onClick={trackCityClick}>
                  <DropdownAnimated
                    state={item.state}
                    city={item.city || item.town}
                    areas={item.suburbs}
                  />
                </DropdownWrapper>
              ))}
            </PlacesColumn>
          </PlacesWrapper>
        )}
      </Content>
    </Wrapper>
  );
};

export default FindClinics;
